import React from 'react';
import TimezonePopup from '../../../TimezonePopup';

import * as MessageHeaderUI from './MessageHeaderUI';
import { globalFormat } from '../../../../utils/formatting';

interface IProps {
  message: any;
}

// Display message header includes: Author Information, CreatedTime, Tags
export default function MessageHeader(props: IProps) {
  const { dateFormat } = globalFormat.getGlobalFormat();
  // find the insight tag, if not closed, display it.
  const insightTag = props.message.tags.find((tag: any) => {
    if (tag.kind === 'INSIGHT' && tag.state !== 'CLOSED') {
      return true;
    }
    return false;
  });
  // find the task tag, if not closed, display it
  const taskTag = props.message.tags.find((tag: any) => {
    if (tag.kind === 'TASK' && tag.state !== 'CLOSED') {
      return true;
    }
    return false;
  });
  // find if the message is replay
  const replyTag = !!props.message.parent;
  return (
    <MessageHeaderUI.HeaderContainer>
      {/* Author Information */}
      <MessageHeaderUI.AuthorInfo>
        <MessageHeaderUI.AuthorAvatar src={props.message.creator.picture} />
        <MessageHeaderUI.AuthorName>
          {props.message.creator.name}
        </MessageHeaderUI.AuthorName>
      </MessageHeaderUI.AuthorInfo>
      <MessageHeaderUI.RightContainer>
        {/* created time */}
        <MessageHeaderUI.SubmitTime
          hasIconsAfter={insightTag || taskTag || replyTag}
        >
          <TimezonePopup
            timestamp={props.message.createdAt}
            dateFormat={dateFormat}
          />
        </MessageHeaderUI.SubmitTime>
        {/* reply Tag and state Tag */}
        {replyTag && <MessageHeaderUI.TagIcon name="reply" />}
        {insightTag && <MessageHeaderUI.TagIcon name="lightbulb" />}
        {taskTag && (
          <MessageHeaderUI.TagIcon
            defaultChecked={taskTag.state === 'COMPLETED'}
            name="tasks"
          />
        )}
      </MessageHeaderUI.RightContainer>
    </MessageHeaderUI.HeaderContainer>
  );
}
